import { render, staticRenderFns } from "./ProPatientsCReportPage.vue?vue&type=template&id=73cce694"
import script from "./ProPatientsCReportPage.vue?vue&type=script&lang=js"
export * from "./ProPatientsCReportPage.vue?vue&type=script&lang=js"
import style0 from "./ProPatientsCReportPage.vue?vue&type=style&index=0&id=73cce694&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports